module.exports = __webpack_public_path__ + "static/media/Link buttons_TeacherLP.d3653bf2.png";